'use client';

import { useEffect, useState } from 'react';


import HeroSection from './HeroSection';
import TrustSignals from './TrustSignals';
import ServiceHighlights from './ServiceHighlights';
import CalculatorEmbed from './CalculatorEmbed';
import PricingTransparency from './PricingTransparency';
import CreatorTestimonials from './CreatorTestimonials';
import CTASection from './CTASection';
import Footer from './Footer';

const LandingPageInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div className="min-h-screen bg-background">
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-4xl mx-auto text-center">
            <div className="animate-pulse space-y-4">
              <div className="h-12 bg-muted rounded-lg w-3/4 mx-auto" />
              <div className="h-6 bg-muted rounded-lg w-1/2 mx-auto" />
              <div className="h-16 bg-muted rounded-lg w-64 mx-auto mt-8" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  const handleScrollToCalculator = () => {
    const calculatorSection = document.getElementById('calculator-section');
    if (calculatorSection) {
      calculatorSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <HeroSection onStartCalculator={handleScrollToCalculator} />
      <TrustSignals />
      <ServiceHighlights />
      <div id="calculator-section">
        <CalculatorEmbed />
      </div>
      <PricingTransparency />
      <CreatorTestimonials />
      <CTASection />
      <Footer />
    </div>
  );
};

export default LandingPageInteractive;